import React from 'react'
import { UserProvider } from './UserProvider'
import Routes from './Routes'

/**
 * Wrap all providers here
 */

export default function ContextWrapper() {
  return (
    <UserProvider>
      <Routes />
    </UserProvider>
  );
}
